<template>
  <div class="activity-nav">
    <div class="new-center-content">
      <div class="new-center-top fl">
        <div class="new-top-nav" :style="{backgroundImage:'url('+imgs+')'}">
          <h1 class="new-top-title fl">A</h1>
          <div class="fl" style="padding-left:4px;">
            <p class="new-top-navtitle">认证活动</p>
            <p class="new-top-ews">ctivity</p>
          </div>
        </div>
        <div class="new-center-tab">
          <div
            class="new-center-dynamic"
            v-for="(item,index) in activityData"
            :key="index"
            @click="tabShow(index+1)"
            :class="{'class-back':isTab == index+1 }"
          >
            {{item}}
            <span class="wl-icon wl-icon-xiangyou fr"></span>
          </div>
        </div>
      </div>
      <div class="new-center-list">
        <h2>{{activityData[isTab-1]}}</h2>
        <div class="new-center-path">
          <div class="crumbs-text">
            <i class="wl-icon-zhuye1"></i>
            <span>当前位置：</span>
            <span @click="goHome" style="cursor: pointer;">网站首页</span>
            <span>></span>
            <span>{{activityData[isTab-1]}}</span>
          </div>
        </div>
      </div>

      <div class="new-center-location" v-if="isTab == 3 || isTab == 4">
        <template>
            省份：
          <el-select v-model="value" @change="getSitesList" clearable placeholder="请选择">
            <el-option
              v-for="item in provinceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
            </el-option>
          </el-select>

            站点名称：
          <el-select v-model="siteName" @change="search" clearable filterable placeholder="请选择">
            <el-option
              v-for="item in SiteList"
              :key="item.Id"
              :label="item.SiteName"
              :value="item.SiteName"
            >
              <span style="float: left">{{ item.SiteName }}</span>
            </el-option>
          </el-select>

        </template>
      </div>
      
      <div class="new-center-box" v-for="(item,index) in siteActivity" :key="index" @click="getList(item.id)">
        <div class="new-center-cemtent">
          <h1><span class="wl-icon-zhedie"></span>{{item.title}}</h1>
          <p>{{item.contentText}}</p>
          <span v-if="item.siteName!=''">来源:{{item.siteName}}</span>
          <span v-else>来源:系统管理员</span>
        </div>
      </div>

      <div class="block">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        v-show="total>0">
        </el-pagination>
    </div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isTab: 1,
      siteId:'',
      siteName:'',
      imgs:require("assets/images/bg-hd.png"),
      value1: "安徽",
      activityData: ["站点活动", "讲师培训", "学员培训", "考证信息"],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      siteActivity:[],
      SiteList:[],
      provinceList:[],
      value:'',
      siteName:''
    };
  },
  created() { 
	  if (this.$route.params.isTab == undefined) {
	      this.isTab = 1
	  } else {
	      this.isTab = this.$route.params.isTab;
	  }
    this.getAttestationList();
    this.getSitesList();
    this.getAllProvinceList();
  },
  computed: {
    association: function() {
      return this.$store.state.association;
    }
  },
  
  methods: {
    tabShow(num) {
      this.isTab = num;
      this.siteName = '';
      this.value = '',
      this.getAttestationList();
    },
    //获取认证活动
    getAttestationList(page){
      var that = this;
      this.$http.post(
        '/api/XOrg/AttestationActivity/getAttestation',
        {
          type: that.isTab,
          associationId: that.association.Id,
          siteName: that.siteName,
          page: page,
          pageSize: this.pageSize
        }
      )
      .then(rst =>{
        if(rst.code == 1){
          that.siteActivity = rst.list;
          that.total = rst.pagination.totalCount;
          that.pageSize = rst.pagination.pageSize;
          that.pageIndex = rst.pagination.pageIndex;
        }else{
          that.$message.warning(rst.msg);
        }
      });
    },
    //获取站点列表
    getSitesList(){
      var that = this;
      this.$http.post(
        '/api/XOrg/AttestationActivity/getSiteList',
        {
         province : that.value
        }
      )
      .then(rst => {
        if(rst.code == 1){
          that.SiteList = rst.siteList
        }else {
          that.$message.warning(res.msg);
        }
        
      })
    },
    //获取省份列表
    getAllProvinceList(){
      var that = this;
      this.$http.post(
        '/api/XOrg/AttestationActivity/getAllProvinceList'
      )
      .then(rst => {
        if (rst.code ==1 ){
          that.provinceList = rst.province;
        }else {
          that.$message.warning(rst.msg);
        }
      })
    },
    //搜索
    search() {
      this.getAttestationList();
    },
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    getList(id) {
      this.$router.push({
        name: "certifiActivList",
        params:{
          isTab:this.isTab,
          activityId : id,
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAttestationList(1);
    },
    handleCurrentChange(val) {
      this.getAttestationList(val);
    }
  }
};
</script>
<style>
</style>

